import type { IconData } from '@stacksjs/iconify-core'

export const leafProtect: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M12.19 35.327q-.402-.349-.786-.731c-6.36-6.36-5.76-17.273 1.34-24.373C23.457-.491 42.116 3.884 42.116 3.884s1.888 8.053.146 16.616M16.711 38c1.37.512 2.814.826 4.289.945\"/><path d=\"M37 9c-5 3.333-27 19.5-27 36m15.196-16.42c.145-1.652 1.172-2.97 2.814-3.202C29.448 25.175 31.656 25 35 25s5.552.175 6.99.378c1.642.232 2.67 1.55 2.815 3.202c.104 1.187.195 2.713.195 4.42c0 4.514-2.382 8.738-6.396 10.804C37.263 44.494 35.954 45 35 45s-2.263-.506-3.604-1.196C27.382 41.738 25 37.514 25 33c0-1.707.091-3.233.196-4.42\"/><path d=\"M31 33.733L34.706 38L40 30\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default leafProtect
